<template>
  <!-- 美食活动页 -->
  <div class="active-trip">
    <div class="bg-pic">
      <!-- 头部图片 -->
      <div class="top-pic">
        <img src="@/assets/images/food_top.png" alt="" />
      </div>
      <!-- 内容 -->
      <div class="contain">
        <div class="box">
          <div class="item">
            <div class="title">亲爱的玩伴：</div>
            <p class="text">
              感谢你对我们的厚爱和支持！爪玩APP的所有数据都来自于每一位会员的无私贡献和精彩分享！作为一个小工具，爪玩APP可以成为你和自己小伙伴专属的好玩地图和美食地图。
            </p>
            <p class="text">
              现在特邀你加入我们，一起筑建属于您自己的个人文化旅游大数据，并且分享给您的粉丝、朋友和家人。
            </p>
          </div>
          <div class="item">
            <div class="title">参与方法：</div>
            <p class="text">
              点击【推荐宝藏美食】创建鲜为人知的宝藏餐厅或者特色美味。如果您的宝藏分享被采纳，将会被推荐给更多的人。您即刻获得【爪玩美食达人】头衔和专属个人身份勋章。另外会得到最高99个爪点奖励。另外，我们会不定期从其中选出翘楚，成为我们的幸运锦鲤，夺取神秘大奖！快来加入我们吧！
            </p>
            <p class="text t2">
              提示：无论您的宝藏推荐是否被采纳，你分享的数据都会保留在您个人的数据中心。您和您的朋友可以随时查看和分享。
            </p>
            <p class="text t2 t3">*活动最终解释权归爪玩所有</p>
          </div>
        </div>
      </div>
      <!-- 按钮 -->
      <div class="btnbox">
        <div class="btn" id="btn">推荐宝藏美食</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    this.init()
  },
  methods: {
    init() {
      var data = OpenInstall.parseUrlParams() ///openinstall.js中提供的工具函数，解析url中的所有查询参数
      new OpenInstall(
        {
          appKey: 'x29emf',
          /*OpenInstall初始化完成的回调函数，可选*/
          onready: function() {
            /*在app已安装的情况尝试拉起app*/
            this.schemeWakeup()

            /*用户点击某个按钮时(假定按钮id为downloadButton)，安装app*/
            const button = document.getElementById('btn')
            const _this = this
            button.onclick = function() {
              _this.wakeupOrInstall()
              return false
            }
          },
        },
        data,
      )
    },
  },
}
</script>

<style lang="less" scoped>
.active-trip {
  width: 100vw;
  .bg-pic {
    width: 100%;
    background-image: url('../assets/images/food_bg.png');
    background-size: contain;

    .top-pic {
      width: 100%;
      height: 40vh;
      img {
        width: 100%;
        height: auto;
        max-height: 40vh;
      }
    }
    .contain {
      padding: 20px;
      .box {
        background-color: #fff7e8;
        padding: 18px 15px;
        border-radius: 8px;
        font-size: 12px;
        color: #555;
        .item {
          margin-bottom: 20px;
          .title {
            background-color: #f6cb48;
            line-height: 13px;
            padding-bottom: 4px;
            padding-top: 1px;
            font-size: 13px;
            margin-bottom: 5px;
            border-radius: 1px;
            display: inline-block;
          }
          .text {
            text-indent: 20px;
            line-height: 19px;
          }
          .t2 {
            text-indent: 0px;
            margin-top: 15px;
            color: #999;
          }
          .t3 {
            color: #999;
          }
        }
        .item:last-child {
          margin: 0;
        }
      }
    }
    .btnbox {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-bottom: 30px;

      .btn {
        display: flex;
        justify-content: center;
        background-image: url('../assets/images/button.png');
        background-size: contain;
        background-repeat: no-repeat;
        width: 50vw;
        height: 60px;
        font-size: 17px;
        letter-spacing: 1px;
        color: #ededed;
        padding-top: 10px;
      }
    }
  }
}
</style>
